import { addContextLog } from "../../infrastructure/log";
import { fileDownloadHandler } from "../../usecases/commons/file-download-handler";
import { parseToCsv } from "../isValidCsv";

export default async function generateCsv({
  title,
  headers,
  rows,
  messageLog,
}) {
  const parseData = parseToCsv({
    headers,
    rows,
  });
  addContextLog("info", messageLog, "download-file", {
    title,
    parseData,
  });
  await fileDownloadHandler(title, parseData);
}
